// Mirrors the server-side policy configured in Firebase Identity Toolkit:
//   min length 12, at least one upper / lower / digit / symbol.
// Keep in sync with the policy set via admin/v2/projects/{project}/config.

export const POLICY = {
  minLength: 12,
  requireUpper: true,
  requireLower: true,
  requireDigit: true,
  requireSymbol: true,
};

export function checkPassword(pw) {
  const checks = {
    length: pw.length >= POLICY.minLength,
    upper: /[A-Z]/.test(pw),
    lower: /[a-z]/.test(pw),
    digit: /[0-9]/.test(pw),
    symbol: /[^A-Za-z0-9]/.test(pw),
  };
  const failures = [];
  if (!checks.length) failures.push(`at least ${POLICY.minLength} characters`);
  if (POLICY.requireUpper && !checks.upper) failures.push('one uppercase letter');
  if (POLICY.requireLower && !checks.lower) failures.push('one lowercase letter');
  if (POLICY.requireDigit && !checks.digit) failures.push('one number');
  if (POLICY.requireSymbol && !checks.symbol) failures.push('one symbol');
  return { ok: failures.length === 0, failures, checks };
}

export function policySummary() {
  return `Must be ${POLICY.minLength}+ characters with upper, lower, number, and symbol.`;
}
